import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '触发器',
    type: 'DT_TRIGGER',
}
